import { render, staticRenderFns } from "./recordSumRankingList.vue?vue&type=template&id=d2d9970c&scoped=true&"
import script from "./recordSumRankingList.vue?vue&type=script&lang=js&"
export * from "./recordSumRankingList.vue?vue&type=script&lang=js&"
import style0 from "./recordSumRankingList.vue?vue&type=style&index=0&id=d2d9970c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d9970c",
  null
  
)

export default component.exports